import { LedgerAccountEvent as ILedgerAccountEvent, Money } from 'models';

import formatCurrency from 'shared/utils/formatCurrency';

import {
  LedgerAccountEventItem,
  LedgerAccountEventText,
} from './LedgerAccountEvent.style';

interface LedgerAccountEventProps {
  ledgerAccountEvent: ILedgerAccountEvent;
}

function getLedgerAccountAmount(credit: Money | null, debet: Money | null) {
  if (credit) {
    return `-${formatCurrency(credit.Value, credit.Code)}`;
  }

  if (debet) {
    return formatCurrency(debet.Value, debet.Code);
  }

  return null;
}

const LedgerAccountEvent = ({
  ledgerAccountEvent,
}: LedgerAccountEventProps) => {
  const {
    LedgerAccountNumber,
    LedgerAccount,
    LedgerAccountCredit,
    LedgerAccountDebet,
  } = ledgerAccountEvent;

  return (
    <LedgerAccountEventItem>
      <LedgerAccountEventText>{LedgerAccountNumber}</LedgerAccountEventText>
      <LedgerAccountEventText>{LedgerAccount?.Name}</LedgerAccountEventText>
      <LedgerAccountEventText>
        {getLedgerAccountAmount(LedgerAccountCredit, LedgerAccountDebet)}
      </LedgerAccountEventText>
    </LedgerAccountEventItem>
  );
};

export default LedgerAccountEvent;
